'use client';

// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-react/build/generate-icons

import { IconPaperclip, iconPaperclipTag } from '@ni/nimble-components/dist/esm/icons/paperclip';
import { wrap } from '../../utilities/react-wrapper';

export type { IconPaperclip };
export { iconPaperclipTag };
export const NimbleIconPaperclip = wrap(IconPaperclip);